import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';
import Modal from './Modal';

interface SimpleModalProps {
  title: string | JSX.Element;
  onCancel: () => void;
  cancel?: JSX.Element;
  submit?: JSX.Element;
  status?: JSX.Element | string;
  className?: string;
  hide?: boolean;
  hideCloseButton?: boolean;
  closeOnClickOutside?: boolean;
  gray?: boolean;
  id?: string;
  children?: React.ReactNode;
}

const SimpleModal: React.FC<SimpleModalProps> = ({
  hide,
  hideCloseButton,
  title,
  cancel,
  submit,
  status,
  onCancel,
  children,
  className,
  closeOnClickOutside = true,
  gray = true,
  id,
}) => {
  const buttonJustify =
    (!submit && cancel) || (!cancel && submit) ? 'justify-end' : 'justify-between';

  return (
    <Modal
      id={id}
      hide={hide}
      className={className}
      css={css`
        .ewebinar-title {
          ${tw`min-w-25e max-w-30e mb-1_5e text-color-cancel text-xl`}
        }
      `}
      closeOnClickOutside={closeOnClickOutside}
      onClose={onCancel}
    >
      <Modal.Header className={'items-center'} gray>
        <Modal.Title>
          <div className='text-xl text-gray-0 pr-1e leading-normal'>{title}</div>
        </Modal.Title>
        {!hideCloseButton && <Modal.Close onClick={onCancel} />}
      </Modal.Header>
      <Modal.Body className='modal-body'>{children}</Modal.Body>
      {(submit || cancel || status) && (
        <Modal.Footer className={`flex flex-col ${gray ? '' : 'border-none pt-0'}`}>
          <div className={`flex w-full text-gray-1 ${buttonJustify}`}>
            {cancel ? (
              React.cloneElement(cancel, {
                onClick: onCancel,
              })
            ) : (
              <div />
            )}

            {submit}
          </div>
          {status}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default SimpleModal;
